/** @file toStoredPuppet: a wire puppet document (clips array) as the stored PuppetDoc (clips by name). */
import type { ImageMeta, PuppetDoc } from '../state/puppetDoc';
import type { WirePuppetDoc } from './editorApi';

/**
 * Clips are keyed by name; images get their id from the key, and `bytes` 0 / `hash` '' because the wire lists only
 * size and mime (the editor never re-hashes; the server keeps the real metadata). Converted once per load.
 */
export function toStoredPuppet(wire: Omit<WirePuppetDoc, 'project'>): PuppetDoc {
  const images: Record<string, ImageMeta> = {};
  for (const [id, meta] of Object.entries(wire.images)) images[id] = { id, size: meta.size, mime: meta.mime, bytes: 0, hash: '' };
  return {
    format: 'pose3d/project@1', id: wire.id, kind: wire.kind, name: wire.name, puppet: wire.puppet,
    clips: Object.fromEntries(wire.clips.map((c) => [c.name, c])), images, revision: wire.revision,
  };
}
